import {
    FontAwesomeIcon,
    FontAwesomeLayers,
    FontAwesomeLayersText,
} from '@fortawesome/vue-fontawesome';
import { AuthService } from '@skinsoft/auth';
import {
    AliasDataStore,
    AliasDataStore as CollaboratorDataStore,
    ContainerDataStore,
    ExpressionDataStore,
    InstitutionDataStore,
    ItemDataStore,
    LocationDataStore,
    ManifestationDataStore,
    MovementDataStore,
    PrintableReportDataStore,
    TaskDataStore,
    ThesaurusDataStore,
    ThesaurusTermDataStore,
    WorkDataStore,
    WorkspaceDataStore,
    TranslationDataStore,
    ArchiveDataStore,
    SpecimenDataStore
} from '@skinsoft/entity';
import { Field, Form, LocalizedDate, LocalizedString } from '@skinsoft/ui';
import BootstrapVue from 'bootstrap-vue';
import Vue from 'vue';
import { ToastPlugin as Toasted } from '@skinsoft/ui';

import { Firewall } from '@skinsoft/auth-ui';
import { ImageTransferHelper, MediaTransferHelper } from '@skinsoft/media-transfer-helper';

Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('font-awesome-layers', FontAwesomeLayers);
Vue.component('font-awesome-layers-text', FontAwesomeLayersText);
Vue.component('s-form', Form);
Vue.component('s-field', Field);
Vue.component('s-firewall', Firewall);
Vue.component('s-localized-date', LocalizedDate);
Vue.component('s-localized-string', LocalizedString);

Vue.use(BootstrapVue);
Vue.use(Toasted);

Vue.use(AuthService);
// router and i18n are wired via app.use() in main.ts instead: v4/v9 no longer ship a Vue-plugin
// default export.

Vue.use(AliasDataStore);
Vue.use(CollaboratorDataStore);
Vue.use(ExpressionDataStore);
Vue.use(ItemDataStore);
Vue.use(LocationDataStore);
Vue.use(ManifestationDataStore);
Vue.use(MovementDataStore);
Vue.use(TaskDataStore);
Vue.use(ThesaurusDataStore)
Vue.use(ThesaurusTermDataStore);
Vue.use(InstitutionDataStore)
Vue.use(TranslationDataStore);
Vue.use(WorkDataStore);
Vue.use(WorkspaceDataStore);
Vue.use(MediaTransferHelper)
Vue.use(ImageTransferHelper)
Vue.use(ContainerDataStore)
Vue.use(PrintableReportDataStore)
Vue.use(ArchiveDataStore)
Vue.use(SpecimenDataStore)

if(process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'dev') {
    Vue.config.devtools = true;
    Vue.config.productionTip = false;
} else {
    Vue.config.devtools = false;
    Vue.config.productionTip = true;
}
